<div class="account-menu">
    <div class="menu-item" id="user-info">
        <svg-icon class="user-icon-container" src="assets/icons/common/account.svg" svgClass="menu-item-icon" alt=""></svg-icon>
        <div class="menu-item-text">
            <div id="username">{{ username() }}</div>
            <div id="email-address">{{ emailAddress() }}</div>
        </div>
        <button class="close-button">
            <img alt="Close Button" src="assets/icons/common/close.svg">
        </button>
    </div>
    @if (termsAvailable()) {
        <button class="menu-item" id="terms-and-conditions" (click)="openTermsAndConditionsModal()">
            <svg-icon src="assets/icons/common/terms.svg" svgClass="menu-item-icon" alt=""></svg-icon>
            <div class="menu-item-text">Terms & Conditions</div>
        </button>
    }
    @if (accessibilityAvailable()) {
        <button class="menu-item" id="accessibility" (click)="openAccessibilityModal()">
            <svg-icon src="assets/icons/common/terms.svg" svgClass="menu-item-icon" alt=""></svg-icon>
            <div class="menu-item-text">Accessibility</div>
        </button>
    }
    <button class="menu-item" id="logout" (click)="logout()">
        <svg-icon src="assets/icons/common/logout.svg" svgClass="menu-item-icon" alt=""></svg-icon>
        <div class="menu-item-text">Log Out</div>
    </button>
</div>
